import React from 'react';
import { withI18n } from '@shopify/react-i18n';
import { Badge } from '@shopify/polaris';
import ProductPrice from 'src/components/views/common/product-list/product-price';
import noProductImage from 'src/assets/images/product/no-image.png';
import { isEmpty, trim } from 'lodash';

interface ProductDetailProps {
  product: any;
  moneyFormat: any;
}

const FieldDetail = props => {
  const { name, value, isBadge } = props;

  if (!trim(value) || isEmpty(value)) {
    return <></>;
  }

  return (
    <div className="product-data">
      <span className="field-name">{name}</span>
      <div className="field-value">{isBadge ? value.map(c => <Badge>{c}</Badge>) : value}</div>
    </div>
  );
};

const ProductDetail = (props: ProductDetailProps) => {
  const { product, i18n, moneyFormat } = props;
  const getOptionValues = name =>
    product.options_with_values
      .filter(op => op.name === name)
      .flatMap(op => op.values)
      .map(v => v.title);

  const variantsHasSku = product.variants.filter(v => v.sku);

  return (
    <div className="BC-Component-ProductDetail">
      <div className="product-image">
        <img src={(product.images || {})['1'] || noProductImage} alt="product" />
      </div>
      <div className="product-info">
        <div className="product-title">
          <span>{product.title}</span>
        </div>
        <div className="product-vendor">
          <span>{product.vendor}</span>
        </div>
        <ProductPrice product={product} moneyFormat={moneyFormat} />
        <FieldDetail
          name={i18n.translate('AdminHTML.Product.ProductFields.size')}
          value={getOptionValues('size')}
          isBadge
        />
        <FieldDetail
          name={i18n.translate('AdminHTML.Product.ProductFields.color')}
          value={getOptionValues('color')}
          isBadge
        />
        <FieldDetail
          name={i18n.translate('AdminHTML.Product.ProductFields.description')}
          value={product.body_html}
        />
        <FieldDetail
          name={i18n.translate('AdminHTML.Product.ProductFields.tags')}
          value={product?.tags}
          isBadge
        />
        <FieldDetail
          name={i18n.translate('AdminHTML.Product.ProductFields.collection')}
          value={product.collections?.map(c => c.title)}
          isBadge
        />
        <FieldDetail
          name={i18n.translate('AdminHTML.Product.ProductFields.productCategory')}
          value={product?.product_category}
        />
        <FieldDetail
          name={i18n.translate('AdminHTML.Product.ProductFields.productType')}
          value={product.product_type}
        />
        {product.variants.length === 1 && variantsHasSku.length === 1 && (
          <FieldDetail
            name={i18n.translate('AdminHTML.Product.ProductFields.sku')}
            value={variantsHasSku[0].sku}
          />
        )}
        {product.variants.length > 1 &&
          variantsHasSku.length >= 1 &&
          variantsHasSku.map(v => (
            <FieldDetail
              name={`${v.title}_${i18n.translate('AdminHTML.Product.ProductFields.sku')}`}
              value={v.sku}
            />
          ))}
      </div>
    </div>
  );
};

export default withI18n()(ProductDetail);
